import { request } from "../../base";
import type { CrmSettings, CrmDashboard } from "./types";

export const crmSettingsApi = {
	// Analytics
	async getDashboard(proId: string, period = "this_month") {
		return request<CrmDashboard>(
			`/api/pro/${proId}/crm/analytics?period=${period}`,
		);
	},

	// Settings
	async getSettings(proId: string) {
		return request<CrmSettings>(
			`/api/pro/${proId}/crm/settings`,
		);
	},

	async updateSettings(
		proId: string,
		data: Partial<
			Pick<
				CrmSettings,
				| "kanbanHeaderDisplay"
				| "autoArchiveEnabled"
				| "autoArchiveWonDays"
				| "autoArchiveLostDays"
			>
		>,
	) {
		return request<CrmSettings>(
			`/api/pro/${proId}/crm/settings`,
			{ method: "PATCH", body: data },
		);
	},
};
